import { APIResponseType } from 'app/apiService/types';
import apiService from '..';

class Makes {
  static ENDPOINT = 'api/v2/makes';

  static async getAllMakes(params?: any): Promise<APIResponseType> {
    try {
      const response = await apiService.get<APIResponseType>(this.ENDPOINT, params);
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default Makes;

